module.exports = __webpack_public_path__ + "img/193.d8d96441.jpg";